export default "__VITE_ASSET__f1c2126f__"